/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RecheckPlatformMCPOnboardingReadinessSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RecheckPlatformMCPOnboardingReadinessRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type RecheckPlatformMCPOnboardingReadinessSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RecheckPlatformMCPOnboardingReadinessSecurity$outboundSchema:
  z.ZodMiniType<
    RecheckPlatformMCPOnboardingReadinessSecurity$Outbound,
    RecheckPlatformMCPOnboardingReadinessSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function recheckPlatformMCPOnboardingReadinessSecurityToJSON(
  recheckPlatformMCPOnboardingReadinessSecurity:
    RecheckPlatformMCPOnboardingReadinessSecurity,
): string {
  return JSON.stringify(
    RecheckPlatformMCPOnboardingReadinessSecurity$outboundSchema.parse(
      recheckPlatformMCPOnboardingReadinessSecurity,
    ),
  );
}

/** @internal */
export type RecheckPlatformMCPOnboardingReadinessRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const RecheckPlatformMCPOnboardingReadinessRequest$outboundSchema:
  z.ZodMiniType<
    RecheckPlatformMCPOnboardingReadinessRequest$Outbound,
    RecheckPlatformMCPOnboardingReadinessRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function recheckPlatformMCPOnboardingReadinessRequestToJSON(
  recheckPlatformMCPOnboardingReadinessRequest:
    RecheckPlatformMCPOnboardingReadinessRequest,
): string {
  return JSON.stringify(
    RecheckPlatformMCPOnboardingReadinessRequest$outboundSchema.parse(
      recheckPlatformMCPOnboardingReadinessRequest,
    ),
  );
}
